import React, { useEffect, useState, useRef } from "react";
import { useFormik, FieldArray, FormikProvider } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import ToastDialog from "components/Common/ToastDialog";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import JoditEditor from "jodit-react";
import { addMandate, getOneDeal, getMandate } from "http/fundLync/deal.helper";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Button,
  FormFeedback,
  Label,
  Select,
  Input,
} from "reactstrap";
import { downloadSystemConfigFile } from "../../http/UAM/systemConfig.helper";
import {
  getEmailTemplateByType
} from "../../http/UAM/emailTemplate.helper";
import { decryptedValue } from "common/utility";

const Emandate = () => {
  const navigate = useNavigate();
  const [dealId, setDealId] = useState('');
  const [dealDetails, setDealDetails] = useState({});
  const [content, setContent] = useState("");
  const [template, setTemplate] = useState('');
  const [mandateId, setMandateId] = useState('');
  const [error, setError] = useState('');
  const editor = useRef(null);
  const [addresssList, setAddresssList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [userSelected, setUserSelected] = useState(false);
  const [addressSelected, setAddressSelected] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [userId, setUserId] = useState('')
  const [isSigned, setIsSigned] = useState(false)
  const [mandateDetails, setMadateDetails] = useState(false)



  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: mandateId || "",
      dealId:dealId || "",
      mandateTemplate: "",
      user:"",
      address:""
    },
    validationSchema: Yup.object({
      mandateTemplate:Yup.string().required("Template should not be empty"),
      user: !mandateId? Yup.string().required("Please select user"):Yup.string(),
      address:!mandateId?  Yup.string().required("Please select address"):Yup.string(),
    }),
    onSubmit: (values) => {
      setConfirmLoading(true)
      const newMandate = {
        dealId: atob(encodedId),
        mandateTemplate: content,
        id: mandateId || false,
        userId:userId,
        reinitiate:isSigned
      };
      const placeholdersRegex = /\(\(([^)]+)\)\)/g;
      const matchedVariables = [];
      let match;
      while ((match = placeholdersRegex.exec(content)) !== null) {
        matchedVariables.push(match[1]);
      }
      if(matchedVariables.length>0){
        setConfirmLoading(false)
        setError('Missing values for placeholder'+ ' '+ matchedVariables.join(', '),)
        setToastInfo({
          message: 'Missing values for placeholder'+ ' '+ matchedVariables.join(', '),
          showToast: true,
          role: "error",
        });
      }else{
        setError(null)
        let message = mandateId ? "Mandate Updated Successfully" : "Mandate Added Successfully"
        addMandate(newMandate)
        .then((response) => {
          setConfirmLoading(false)
          setToastInfo({
            message: message,
            showToast: true,
            role: "success",
          });
          setTimeout(() => {
            const user = decryptedValue(localStorage.getItem("user"));
            navigate(`/${user.roleName}/listDeal`);
          }, 2000);
        })
        .catch((error) => {
          console.error(error);
          setConfirmLoading(false)
        });
      }
    },
  });

  const [toastInfo, setToastInfo] = useState({
    message: "",
    showToast: false,
    role: "",
  });

  const urlParams = new URLSearchParams(window.location.search);
  const encodedId = urlParams.get("id");

  useEffect(() => {
    if (encodedId) {
      setDealId(atob(encodedId));
    } else {
      console.log("No Deal ID");
    }
  }, [encodedId]);

  useEffect(() => {
    if (dealId) {
      getOneDeal({ id: dealId })
        .then((response) => {
          if (response) {
            setDealDetails(response);
            let addList = response?.entity?.addresses?.map((ele)=>{
              const addressParts = [
                ele.address1,
                ele.address2,
                ele.address3,
                // ele.city,
                // ele.state,
                ele.pincode
              ].filter(part => part);
              
              let address = addressParts.join(', ');
              return {address, id:ele.id}
            })
            let userList = response?.entity?.users?.map((ele)=>{
              const addressParts = [
                ele.firstName,
                ele.lastName,
              ].filter(part => part);
              
              let user = addressParts.join(' ');
              return {user, id:ele.id}
            })
            if(response.isEsign == '2'){
              setIsSigned(true)
            }
            if(userList.length == 0){
              setToastInfo({
                message: 'No user found',
                showToast: true,
                role: "error",
              });
              setUserSelected('((user_name))')
              validation.setFieldValue('user','((user_name))')
            }
            if(addList.length == 0){
              setToastInfo({
                message: 'No address found',
                showToast: true,
                role: "error",
              });
              setAddressSelected('((address))')
              validation.setFieldValue('address','((address))')
            }
            setAddresssList(addList)
            setUserList(userList)
            if(userList.length==1){
              setUserId(userList[0].id)
              setUserSelected(userList[0].user)
              validation.setFieldValue('user',userList[0].user)
            }
            if(addList.length==1){
              setAddressSelected(addList[0].address)
              validation.setFieldValue('address',addList[0].address)
            }
          } else {
            console.log("Some error occurred while fetching Deal");
          }
        })
        .catch((error) => {
          console.log(error);
        });

        getMandate({ dealId })
        .then((response) => {
          if (response && response.mandateTemplate) {
            setTemplate(response.mandateTemplate)
            setMadateDetails(response)
            setMandateId(response.id)
            setUserSelected(true)
            setAddressSelected(true)
            if(response.isSigned){
              setIsSigned(response.isSigned)
            }
          }else{
            getEmailTemplateByType({ emailType: 'mandate_template' }).then((response) => {
              if (response && response.data && response.data.emailBody) {
                setTemplate(response.data.emailBody)
              }
            })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [dealId]);

  useEffect(() => {
    if (Object.keys(dealDetails).length === 0) return;
    if(template){
      const replacedHtml = replacePlaceholders(template, dealDetails,addressSelected, userSelected);
      validation.setFieldValue('mandateTemplate', replacedHtml);
      setContent(replacedHtml);
    }else{
      const replacedHtml = replacePlaceholders(initialHtml, dealDetails,addressSelected, userSelected);
      validation.setFieldValue('mandateTemplate', replacedHtml);
      setContent(replacedHtml);
    }
  }, [dealDetails,addressSelected, userSelected,template]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const replacePlaceholders = (html, dealData, address, user) => {
    const tableRows = dealData.dealProductCommercials.map(row => {
      let integrationFees = row.commercials[0]?.integrationFees?.Value
      let syndicationFees = row.commercials[0]?.syndicationFees?.Value
      let platformCharges = row.commercials[0]?.platformCharges?.Value
      const isTradeasyProduct = dealData.prospectiveProduct === 'TradEasy';
      if (isTradeasyProduct) {
       
        integrationFees = integrationFees ? `₹${integrationFees}${row.commercials[0]?.integrationFees?.Frequency ? ` (${row.commercials[0].integrationFees.Frequency})` : ''}` : '-';
        syndicationFees = syndicationFees ? `₹${syndicationFees}${row.commercials[0]?.syndicationFees?.Frequency ? ` (${row.commercials[0].syndicationFees.Frequency})` : ''}` : '-';
        platformCharges = platformCharges ? `₹${platformCharges}` : '-';
      } else {
       
        if (row.commercials[0]?.integrationFees?.Type === 'Percentage') {
          integrationFees = integrationFees ? `${integrationFees}%${row.commercials[0]?.integrationFees?.Frequency ? ` (${row.commercials[0].integrationFees.Frequency})` : ''}` : '-';
        } else {
          integrationFees = integrationFees ? `₹${integrationFees}${row.commercials[0]?.integrationFees?.Frequency ? ` (${row.commercials[0].integrationFees.Frequency})` : ''}` : '-';
        }
  
        if (row.commercials[0]?.syndicationFees?.Type === 'Percentage') {
          syndicationFees = syndicationFees ? `${syndicationFees}%${row.commercials[0]?.syndicationFees?.Frequency ? ` (${row.commercials[0].syndicationFees.Frequency})` : ''}` : '-';
        } else {
          syndicationFees = syndicationFees ? `₹${syndicationFees}${row.commercials[0]?.syndicationFees?.Frequency ? ` (${row.commercials[0].syndicationFees.Frequency})` : ''}` : '-';
        }
  
     
        platformCharges = platformCharges ? `₹${platformCharges}` : '-';
      }
  
      if (row.commercials[0]?.platformCharges?.Type === 'NVG') {
        let NVG = row.commercials[0]?.platformCharges?.NVG || '';
        let Benchmark = row.commercials[0]?.platformCharges?.Benchmark || '';
        let BenchmarkRate = row.commercials[0]?.BenchmarkRate || '';
        let MarkupOverBenchmark = row.commercials[0]?.MarkupOverBenchmark || '';
        let Occurrence = row.commercials[0]?.platformCharges?.Frequency === 'Recurring' ? row.commercials[0]?.platformCharges?.Occurrence : row.commercials[0]?.platformCharges?.Frequency;
  
        if (BenchmarkRate == 0 && MarkupOverBenchmark == 0) {
          platformCharges = `${NVG}% of (Discount percentage per annum) billed on ${Occurrence} basis`;
        } else {
          platformCharges = `${NVG}% of (Discount percentage per annum - ${Benchmark} + ${MarkupOverBenchmark}%) billed on ${Occurrence} basis`;
        }
      }
      return `<tr>
                <td  style='border:1px solid black';>${row.productType}</td>
                <td  style='border:1px solid black';>${row.product}</td>
                <td  style='border:1px solid black';>${row.subProduct}</td>
                <td  style='border:1px solid black';>${integrationFees || '-'}</td>
                <td  style='border:1px solid black';>${syndicationFees || '-'}</td>
                <td  style='border:1px solid black';>${platformCharges || '-'}</td>
              </tr>`;
    });
   
    const placeholderMappings = {
      c_date: formatDate(dealData.createdAt),
      user_name: user,
      address: address,
      product_name: getProductName(dealData.dealProductCommercials),
      loan_type: dealData?.loanType || '((loan_type))',
      entity_name: dealData.entity.entityName,
      entity_type: dealData.entity.entityType,
      entity_constitution: dealData.entity.entityConstitution,
      dealNotes:dealData.dealNotes || '-',
      tableData: tableRows.join(''),
      current_date:formatDate(new Date())
    };

    let replacedHtml = html;
    for (const [placeholderKey, value] of Object.entries(placeholderMappings)) {
      const placeholder = `((${placeholderKey}))`;
      if (value !== undefined) {
        replacedHtml = replacedHtml.replaceAll(placeholder, value);
      }
    }
    
    return replacedHtml;
  };

  const navigateBack = () => {
    navigate(-1);
  };

  const config = {
    removeButtons: ['about'],
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
  };

  const initialHtml = `
<div style="margin: 0 auto; padding: 20px; font-family: Arial, sans-serif; line-height: 1.6;text-align:justify" id='pdf-content'>
  <div style="display: flex; justify-content: space-between; align-items: flex-start;">
    <div>
      <p>To,</br>
        ((user_name))</br>
        ((address))</p>
    </div>
    <div style="text-align: right;">
      <p>Date: ((c_date))</p>
    </div>
  </div>
  <div>
    <p>Subject: MOU Mandate Letter - For ((product_name))</p>
  </div>
  <div>
    <p>Dear Sir,</p>
    <p>This exclusive mandate is intended to outline the terms and conditions of our professional engagement and set
      forth our mutual understanding of the scope and duration of our business relationship. ((product_name))
      requirement through Cashinvoice Platform in any form of ((loan_type)).</p>
    <p>This mandate is intended to outline the terms and conditions of our professional engagement and set forth our
      mutual understanding of the scope and duration of our business relationship.</p>
    <ul>
      <li><strong>Scope of Services:</strong> ((product_name)) and any similar product for ((entity_name)).</li>
      <li><strong>Duration:</strong> This exclusive mandate shall be in effect for a period of 3 years starting from
        date of this letter for all new Disbursement and enhancement. During this period, ((entity_name)), agrees to
        exclusively engage with Indinvoice Tech Solutions Private Limited (Cashinvoice) for the specified services
        mentioned in Section 1 for all new disbursement and enhancement </li>
      <li><strong>Responsibilities of Cashinvoice:</strong>
        <ul>
          <li>Preparing Detail and Structuring of Deal.</li>
          <li>Preparing detailed note and Presenting to Financier.</li>
          <li>Engage Financier for the programme.</li>
          <li>Keep ((entity_name)) informed about all development on periodic basis.</li>
          <li>Provide Demo and Concept to ((entity_name)).</li>
          <li>End to end closure of process and Programme.</li>
          <li>Programme Rollout with Financier</li>
        </ul>
      </li>
      <li><strong>Responsibilities of ((entity_name)):</strong>
        <ul>
          <li>Provide all detail as required by Cashinvoice.</li>
          <li>Make themselves available for meeting with Financier.</li>
          <li>Route all financier (Bank/ NBFC/ Institution/ Platform) through Cashinvoice if there is any interest shown.
          </li>
          <li>In Case of overdue – stop supply to the distributors/Reseller/channel partner in Channel finance program.
          </li>
          <li>To support Cashinvoice for curing Channel Partner overdues on a best effort basis.</li>
        </ul>
      </li>
      <div>
        <li><strong>Commercials:</strong></li>
        <table style="border-collapse: collapse; width: 99.7323%;">
          <thead>
            <tr>
              <th style="width: 18.0115%;border:1px solid black"><strong>Product Type</strong></th>
              <th style="width: 15.4179%;border:1px solid black"><strong>Product Name</strong></th>
              <th style="width: 16.6667%;border:1px solid black"><strong>Sub </strong><strong>Products</strong></th>
              <th style="width: 16.6667%;border:1px solid black"><strong>Integration</strong> <strong>Fees</strong></th>
              <th style="width: 16.6667%;border:1px solid black"><strong>Syndication charges</strong></th>
              <th style="width: 16.6667%;border:1px solid black"><strong>Platform Charges</strong></th>
            </tr>
          </thead>
          <tbody>
            ((tableData))
          </tbody>
        </table>
      </div>
      <li><strong>Notes:&nbsp;</strong>((dealNotes)).</li>
      <li><strong>Termination:</strong> Either party may terminate this exclusive mandate by providing 30 days written
        notice to the other party. In the event of termination, both parties agree to cooperate and ensure a smooth
        transition of services.</li>
      <li><strong>Governing Law and Jurisdiction:</strong>This exclusive mandate shall be governed by and construed in
        accordance with the laws of Mumbai. Any disputes arising out of or in connection with this agreement shall be
        subject to the exclusive jurisdiction of the courts of Mumbai.</li>
      <li><strong>Entire Agreement:</strong>This is the mandate letter which constitutes the agreement between M/s.
        Indinvoice Tech Solutions Private Limited and ((entity_name)) with respect to the subject matter herein
        and supersedes all prior discussions, understandings, or agreements, whether oral or written with respect to the
        subject matter hereof. This letter shall not be changed, modified or amended, unless in writing and signed by
        the parties. This letter is on principal-to-principal basis. No failure on the part of Cashinvoice to exercise
        or delay in exercising any of its rights will be deemed a waiver thereof, nor will any single or partial
        exercise preclude any further or other exercise of such or any other right.</li>
      <li>This letter shall constitute an effective, binding agreement on the part of each of the undersigned. Further
        ((entity_name)) understands that this letter is exclusive and agree that they shall not enter into any other
        similar arrangement.</li>
      <li><strong>Exclusivity Clause:</strong>In case transaction Is closed by the company or any related party with the
        introduced party (Financier) within 3 year of the expiry or termination of this agreement, Indinvoice Tech
        Solutions Private Limited will be eligible and shall be entitled for the fees agreed upon by the company.</li>
      <li><strong>Confidentiality:</strong> Both parties agree to maintain the confidentiality of any proprietary,
        sensitive, or confidential information exchanged during the course of the exclusive mandate and shall not
        disclose such information to any third party. Confidential information shall mean any and all information
        disclosed to or otherwise acquired by the Customer including its affiliates, directors, officers and employees
        from the Cashinvoice, whether communicated in writing, orally, electronically, photographically, or in recorded
        or any other form, including, but not limited to operating information and strategies, data, media, client list,
        target clients, know-how, designs, drawings, specifications, source codes, technical information, concepts,
        reports, methods, processes, techniques, business or marketing plan, financial affairs, personnel matters,
        operating procedures, operations, devices, and the like, whether or not the foregoing information is patented,
        tested, reduced to practice, or subject to copyright.</li>
    </ul>
  </div>

  <div>
    <p>Please sign and return a copy of this letter to indicate your acceptance of the exclusive mandate. Upon receipt,
      we will countersign and return a fully executed copy for your records.</p>
    <p>We are excited about the opportunity to work exclusively with ((entity_name)) and are committed to
      providing the highest quality of service. If you have any questions or require further clarification, please do
      not hesitate to contact me.</p>
    <p>Thank you for your trust and partnership.</p>
    <div style="margin-top: 40px;">
      <p>Yours sincerely, </br> Arun Poojari </br>Co Founder and CEO,
        </br>Indinvoice Tech Solutions Pvt Ltd (Cashinvoice)
        </br></br>Accepted and Agreed
        </br>((entity_name))
        </br><strong>Date:</strong>((current_date))</p>
    </div>
  </div>

</div>
`;

  const getProductName = (productList)=>{
    let productListNames = [...new Set(productList?.map((ele) => ele.product))];
    return productListNames.join(', ')
  }

  const handleToast = (info) => {
    setToastInfo(info);
  };

  function formatFunction(file, showToastCallback) {
  
    const str = file.substring(file.indexOf("com") + 4);
    const filename = file.substring(file.lastIndexOf("/") + 1);
    const ext = str.split(".").pop();
    const obj = {
      fileName: str,
    };
  
    downloadSystemConfigFile(obj)
      .then((response) => {
        if (response.code === 200) {
          downloadFile(response.result, ext, filename);
          showToastCallback({
            message: "Downloaded successfully",
            showToast: true,
            role: "success",
          });
        } else {
          showToastCallback({
            message: response.message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error) => {});
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={`E-Mandate For - ${dealDetails.dealName}`} />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <FormikProvider value={validation}>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      className="mt-4"
                    >
                      <Row>
                        {mandateDetails?.mandateFile && (<Col sm="12" >
                          <div className="d-flex gap-2 justify-content-end mt-2 mb-3">
                            <Button
                              type="button"
                              color='success'
                              className="btn-rounded me-2 mt-2"
                              onClick={() => { formatFunction(mandateDetails?.mandateFile, handleToast) }}
                              title={"Download Mandate Letter"}
                              outline
                            >
                              <i
                                className="mdi mdi-download"
                              ></i>{" "}
                              Download
                            </Button>
                          </div>
                        </Col>)}
                       {mandateId == '' && userList.length>1 &&( <Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Select User*
                          </Label>
                          <Input
                            name="user"
                            type="select"
                            placeholder="Select User"
                            onChange={(e) => {
                              const selectedKey = e.target.selectedOptions[0].getAttribute('data-key');
                              setUserId(Number(selectedKey))
                              setUserSelected(e.target.value)
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.user
                            }
                            invalid={
                              validation.touched.user &&
                              validation.errors.user
                            }
                          >
                            <option value="" disabled>
                              Select User
                            </option>
                            {userList.map(
                              (option, index) => (
                                <option
                                  key={option.id}
                                  value={option.user}
                                  data-key={option.id}
                                >
                                  {option.user}
                                </option>
                              )
                            )}
                          </Input>
                          {validation.touched.user &&
                            validation.errors.user ? (
                            <FormFeedback type="invalid">
                              {validation.errors.user}
                            </FormFeedback>
                          ) : null}
                        </Col>)}
                        
                        {mandateId == '' && addresssList.length>1 && (<Col sm="12" md="6">
                          <Label className="form-label mt-4">
                            Select Address*
                          </Label>
                          <Input
                            name="address"
                            type="select"
                            placeholder="Select Address"
                            onChange={(e) => {
                              setAddressSelected(e.target.value)
                              validation.handleChange(e);
                            }}
                            onBlur={validation.handleBlur}
                            value={
                              validation.values.address
                            }
                            invalid={
                              validation.touched.address &&
                              validation.errors.address
                            }
                          >
                            <option value="" disabled>
                              Select Address
                            </option>
                            {addresssList.map(
                              (option, index) => (
                                <option
                                  key={option.id}
                                  value={option.address}
                                >
                                  {option.address}
                                </option>
                              )
                            )}
                          </Input>
                          {validation.touched.address &&
                            validation.errors.address ? (
                            <FormFeedback type="invalid">
                              {validation.errors.address}
                            </FormFeedback>
                          ) : null}
                        </Col>)}

                          <Label className="mt-4"></Label>

                        {(userSelected && addressSelected && <Col sm={12}>
                          <JoditEditor
                            ref={editor}
                            value={content}
                            config={config}
                            onBlur={newContent => setContent(newContent)}
                          />
                        </Col>)}

                        {(validation.touched.mandateTemplate && error && userSelected && addressSelected) ? (
                          <p style={{ color: "rgb(245,116,116)", fontSize: "11px" }}>
                            {error}
                          </p>
                        ) : null}
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end" style={{ margin: "20px 0" }}>
                            <Button
                              type="button"
                              outline
                              color="success"
                              onClick={navigateBack}
                            >
                              Back
                            </Button>
                            <Button
                              type="submit"
                              color="success"
                              className="save-customer"
                              style={{ marginLeft: "7px" }}
                            >
                              {confirmLoading && (
                                <span
                                  className="spinner-border spinner-border-sm ms-2 me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}
                              {confirmLoading && <span>{isSigned ? 'Reinitiating': 'Saving'}</span>}
                              {!confirmLoading && <span>{isSigned ? 'Reinitiate Mandate': 'Save'}</span>}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

function formatFunction(file) {
  const str = file.substring(file.indexOf("com") + 4);
  const filename = file.substring(file.lastIndexOf("/") + 1);
  const ext = str.split(".").pop();
  const obj = {
    fileName: str,
  };
  downloadSystemConfigFile(obj)
    .then((response) => {
      if (response.code === 200) {
        downloadFile(response.result, ext, filename);
      }
    })
    .catch((error) => {
    });
}

function downloadFile(base64String, ext, fileName) {
  let source = "";
  if (ext == "zip") {
    source = `data:application/zip;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();
  } else {
    source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.click();

  }
}

export default Emandate;


